import { useQuery } from '@tanstack/react-query';
import { gql } from '@/utilities/gql';
import type { ResultOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const COMPANY_UPDATE = gql(`
  fragment companyUpdate on CompanyUpdate @_unmask {
    id
    company {
      id
      name
      tickerSymbol
      canonicalURL
      info {
        url
        hasLogo
      }
    }
    type
    time
    isRecent
    title
    description
    name
    virtual
    announcementDate
    url
    keyDevTypeId
  }
`);

export const useUpdates = (id) =>
  useQuery({
    queryKey: ['PORTFOLIO_UPDATES', id],
    queryFn: async () => {
      const response = await gqlClient.request(
        gql(
          `
          query getPortfolioUpdates($id: String!) {
            Portfolio(id: $id) {
              updates {
                earnings {
                  ...companyUpdate
                }
                narrative {
                  ...companyUpdate
                }
                valuations {
                  ...companyUpdate
              }
                dividends {
                  ...companyUpdate
                }
                people {
                  ...companyUpdate
                }
                riskAndLegal {
                  ...companyUpdate
                }
                other {
                  ...companyUpdate
                }
              }
            }
          }
        `,
          [COMPANY_UPDATE]
        ),
        {
          id,
        },
        undefined
      );
      return response;
    },
  });

export type PortfolioUpdates = NonNullable<
  ReturnType<typeof useUpdates>['data']
>['Portfolio']['updates'];

export type Section = keyof PortfolioUpdates;

export type PortfolioUpdate = ResultOf<typeof COMPANY_UPDATE>;
